import React, { ChangeEvent, useEffect } from 'react'

import { usePAWStore } from '@rewardops/ui'

import { useTranslation } from '~/app/i18n/client'

export const DateSelector: React.FC = () => {
  const { t: translate } = useTranslation()
  const { date, setDate, setDateLabel } = usePAWStore((state) => state)

  const currentMonth = new Date().getMonth() + 1
  const currentYear = new Date().getFullYear()

  const options: { key: string; value: Record<string, number> }[] = [
    {
      key: 'thisMonth',
      value: {
        month: currentMonth,
        year: currentYear,
      },
    },
    {
      key: 'lastMonth',
      value: {
        month: new Date().getMonth() || 12,
        year: new Date().getMonth() === 0 ? currentYear - 1 : currentYear,
      },
    },
    {
      key: 'programYTD',
      value: {
        year: currentYear,
      },
    },
  ]

  useEffect(() => {
    if (!date) return

    const selectedOption = options?.find(
      (option) => JSON.stringify(option?.value) === JSON.stringify(date),
    )

    if (selectedOption) {
      setDateLabel(
        translate(`pawDashboards.dateSelector.options.${selectedOption.key}`),
      )
    }
  }, [date])

  const onSelectDate = (e: ChangeEvent<HTMLSelectElement>) => {
    setDate(JSON.parse(e.target.value))
  }

  return (
    <div
      id="paw-dashboard-date-selector"
      data-testid="paw-dashboard-date-selector"
      className="flex items-center gap-2"
    >
      <div
        id="date-selector-label"
        className="text-xs font-bold uppercase tracking-wide text-gray-400"
      >
        {translate('pawDashboards.dateSelector.label')}
      </div>
      <select
        onChange={onSelectDate}
        defaultValue={JSON.stringify(date)}
        className="rounded-md border border-gray-200 px-4 py-2 text-sm"
      >
        {options?.map((option) => (
          <option key={option?.key} value={JSON.stringify(option?.value)}>
            {translate(`pawDashboards.dateSelector.options.${option?.key}`)}
          </option>
        ))}
      </select>
    </div>
  )
}
